var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionOpenstreetmapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_openstreetmap_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 14.0001C15.4329 14.0001 16.9999 12.4331 16.9999 10.5001C16.9999 8.56708 15.4329 7.00008 13.4999 7.00008C11.5669 7.00008 9.99992 8.56708 9.99992 10.5001C9.99992 12.4331 11.5669 14.0001 13.4999 14.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5335 21.0625L16.2979 22.0153L21.0624 21.0625L22.0153 16.298L21.0624 11.5335L22.0153 6.76909L21.0624 2.00464L16.2979 2.95753L11.5335 2.00464L6.76903 2.95753L2.00458 2.00464L2.95747 6.76909L2.00458 11.5335L2.95747 16.298L2.00458 21.0625L6.76903 22.0153L11.5335 21.0625ZM13.4999 16.0001C16.5375 16.0001 18.9999 13.5376 18.9999 10.5001C18.9999 7.46251 16.5375 5.00008 13.4999 5.00008C10.4624 5.00008 7.99992 7.46251 7.99992 10.5001C7.99992 11.6576 8.35748 12.7316 8.96818 13.6176L5.2928 17.293C4.90228 17.6835 4.90228 18.3167 5.2928 18.7072C5.68333 19.0977 6.31649 19.0977 6.70702 18.7072L10.3824 15.0318C11.2684 15.6425 12.3424 16.0001 13.4999 16.0001Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionOpenstreetmapLogo);
export default __webpack_public_path__ + "static/media/ic_action_openstreetmap_logo.aed6ea11552a855f4ee7b6a016cb10f8.svg";
export { ForwardRef as ReactComponent };